import LngLatFormat from "../Enums/LngLatFormat";
import DistanceUnit from "../UI/MeasureTool/DistanceUnit"; // TODO: deffo consider moving! (to enums)
import DistanceUtil from "../UI/MeasureTool/DistanceUtil"; // TODO: consider moving
import clamp from "./Misc/clamp";
import roundFloat from "./Misc/roundFloat";
import wrap from "./Misc/wrap";
import StringHelper from "./StringHelper";
import ValidationHelper from "./ValidationHelper";

import bbox from "@turf/bbox";
import { lineString } from "@turf/helpers";
import length from "@turf/length";

class GeoHelper {

}

/*
 * forEachFunction takes two number params
 * e.g. (lng, lat) => { .. do stuff .. };
 * Useful if you want to gather all coordinates into a list.
 */
GeoHelper.forEachFeatureCoordinate = (feature, forEachFunction) => {
	GeoHelper.forEachFeatureCoordinateRef(feature, (coords) => {
		forEachFunction(coords[0], coords[1]);
		return coords;
	});
};

/*
 * forEachFunction takes one array/lnglatlike param
 * e.g. (coords[2]) => { .. do stuff .. return coords }
 * Useful if you want to modify all coordinates to a new coordinates space.
 */
GeoHelper.forEachFeatureCoordinateRef = (feature, forEachFunction) => {
	if (GeoHelper._isDeepestCoordinate(feature.geometry.coordinates)) {
		feature.geometry.coordinates = forEachFunction(feature.geometry.coordinates);
	}
	else {
		for (let j = 0; j < feature.geometry.coordinates.length; j++) {
			if (GeoHelper._isDeepestCoordinate(feature.geometry.coordinates[j])) {
				feature.geometry.coordinates[j] = forEachFunction(feature.geometry.coordinates[j]);
			}
			else {
				for (let k = 0; k < feature.geometry.coordinates[j].length; k++) {
					if (GeoHelper._isDeepestCoordinate(feature.geometry.coordinates[j][k])) {
						feature.geometry.coordinates[j][k] = forEachFunction(feature.geometry.coordinates[j][k]);
					}
					else {
						for (let l = 0; l < feature.geometry.coordinates[j][k].length; l++) {
							if (GeoHelper._isDeepestCoordinate(feature.geometry.coordinates[j][k][l])) {
								feature.geometry.coordinates[j][k][l] = forEachFunction(feature.geometry.coordinates[j][k][l]);
							}
						}
					}
				}
			}
		}
	}
};
GeoHelper._isDeepestCoordinate = (coordinates) => {
	return (typeof coordinates === "object" && coordinates.length === 2 &&
			typeof coordinates[0] === "number" &&
			typeof coordinates[1] === "number");
};

// Credit where it's due: https://gist.github.com/onderaltintas/6649521
GeoHelper.degreesToMeters = (lng, lat) => {
	const x = lng * 20037508.34 / 180;
	let y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
	y = y * 20037508.34 / 180;
	return [x, y];
};
// Credit where it's due: https://gist.github.com/onderaltintas/6649521
GeoHelper.metersToDegrees = (x, y) => {
	const lng = x * 180 / 20037508.34;
	const lat = Math.atan(Math.exp(y * Math.PI / 20037508.34)) * 360 / Math.PI - 90;
	return [lng, lat];
};
GeoHelper.toWGS84 = (esriFeatureLayer, geojsonFeature) => {
	if (!esriFeatureLayer.spatialReference.isWGS84) {
		GeoHelper.forEachFeatureCoordinateRef(geojsonFeature, (coords) => {
			coords = GeoHelper.metersToDegrees(coords[0], coords[1]);
			return coords;
		});
	}
	else {
		console.warn("feature may already be in wgs84");
	}
	return geojsonFeature;
};

GeoHelper.feetToMbar = (inputFeet) => {
	// From: https://www.sensorsone.com/altitude-pressure-units-conversion/
	// ft	m	mbar	psi	mmHg	inHg
	const table = `-5000	-1524.0	1210.23	17.553	907.75	35.738
-4000	-1219.2	1168.55	16.948	876.48	34.507
-3000	-914.40	1128.03	16.361	846.09	33.311
-2000	-609.60	1088.66	15.790	816.56	32.148
-1000	-304.80	1050.41	15.235	787.87	31.018
-900	-274.32	1046.64	15.180	785.05	30.907
-800	-243.84	1042.89	15.126	782.23	30.796
-700	-213.36	1039.15	15.072	779.42	30.686
-600	-182.88	1035.41	15.017	776.62	30.576
-500	-152.40	1031.69	14.963	773.83	30.466
-400	-121.92	1027.98	14.910	771.05	30.356
-300	-91.440	1024.28	14.856	768.28	30.247
-200	-60.960	1020.59	14.802	765.51	30.138
-100	-30.480	1016.92	14.749	762.75	30.030
-50	-15.240	1015.08	14.723	761.37	29.975
0	0	1013.25	14.696	760.00	29.921
50	15.240	1011.42	14.669	758.63	29.867
100	30.480	1009.59	14.643	757.26	29.813
200	60.960	1005.95	14.590	754.52	29.706
300	91.440	1002.31	14.537	751.80	29.598
400	121.92	998.689	14.485	749.08	29.491
500	152.40	995.075	14.432	746.37	29.385
600	182.88	991.472	14.380	743.67	29.278
700	213.36	987.880	14.328	740.97	29.172
800	243.84	984.298	14.276	738.28	29.066
900	274.32	980.727	14.224	735.61	28.961
1000	304.80	977.166	14.173	732.93	28.856
2000	609.60	942.129	13.664	706.65	27.821
3000	914.40	908.117	13.171	681.14	26.817
4000	1219.2	875.105	12.692	656.38	25.842
5000	1524.0	843.073	12.228	632.36	24.896
6000	1828.8	811.996	11.777	609.05	23.978
7000	2133.6	781.854	11.340	586.44	23.088
8000	2438.4	752.624	10.916	564.51	22.225
9000	2743.2	724.285	10.505	543.26	21.388
10000	3048.0	696.817	10.106	522.66	20.577
15000	4572.0	571.820	8.2935	428.90	16.886
20000	6096.0	465.633	6.7534	349.25	13.750
25000	7620.0	376.009	5.4536	282.03	11.104
30000	9144.0	300.896	4.3641	225.69	8.8855
35000	10668	238.423	3.4580	178.83	7.0406
40000	12192	187.54	2.7200	140.67	5.5381
45000	13716	147.48	2.1390	110.62	4.3550
50000	15240	115.97	1.6821	86.987	3.4247
55000	16764	91.199	1.3227	68.405	2.6931
60000	18288	71.717	1.0402	53.792	2.1178
65000	19812	56.397	0.8180	42.301	1.6654
70000	21336	44.377	0.6436	33.286	1.3105
75000	22860	34.978	0.5073	26.236	1.0329
80000	24384	27.615	0.4005	20.713	0.8155
85000	25908	21.837	0.3167	16.379	0.6448
90000	27432	17.296	0.2509	12.973	0.5107
95000	28956	13.721	0.1990	10.291	0.4052
100000	30480	10.902	0.1581	8.1769	0.3219`;

	// Filthy hacks! All of it.
	inputFeet = parseFloat(inputFeet);

	if (inputFeet <= -5000) {
		return 1210.23;
	}
	else if (inputFeet >= 100000) {
		return 10.902;
	}

	const lines = table.split("\n");
	for (let i = 0; i < lines.length - 1; i++) {
		const line = lines[i];
		const columns = line.split("\t");
		const ft = parseFloat(columns[0]);
		const mbar = parseFloat(columns[2]);

		const nextLine = lines[i + 1];
		const nextColumns = nextLine.split("\t");
		const nextFt = parseFloat(nextColumns[0]);
		const nextMbar = parseFloat(nextColumns[2]);

		if (inputFeet === ft) {
			return mbar;
		}
		if (inputFeet >= ft && inputFeet <= nextFt) {
			// Average the output
			const diffFt = nextFt - ft;
			const t = inputFeet - ft;

			const progressNormalised = t / diffFt; // from 0 to 1.

			const diffMbar = Math.abs(nextMbar - mbar);
			return mbar - (progressNormalised * diffMbar);
		}
	}
	return null;
};

GeoHelper.clampLatLng = (latlng) => {
	latlng[0] = clamp(latlng[0], -90, 90);
	latlng[1] = clamp(latlng[1], -180, 180);
	return latlng;
};
GeoHelper.clampLngLat = (lngLat) => {
	lngLat[0] = clamp(lngLat[0], -180, 180);
	lngLat[1] = clamp(lngLat[1], -90, 90);
	return lngLat;
};
GeoHelper.clampLng = (lng) => {
	return clamp(lng, -180, 180);
};
GeoHelper.clampLat = (lat) => {
	return clamp(lat, -90, 90);
};
GeoHelper.clampCoord = (val, lng = true) => {
	if (lng) {
		return GeoHelper.clampLng(val);
	}
	return GeoHelper.clampLat(val);
};
GeoHelper.wrapLngLat = (lngLat) => {
	lngLat[0] = wrap(lngLat[0], -180, 180);
	lngLat[1] = wrap(lngLat[1], -90, 90);
	return lngLat;
};
GeoHelper.wrapCoord = (val, lng = true) => {
	if (lng) {
		return GeoHelper.wrapLng(val);
	}
	return GeoHelper.wrapLat(val);
};
GeoHelper.wrapLng = (lng) => {
	return wrap(lng, -180, 180);
};
GeoHelper.wrapLat = (lat) => {
	return wrap(lat, -90, 90);
};
GeoHelper.isValidLngLat = (str) => {
	if (str.indexOf(",") <= 0) {
		return false;
	}
	const parts = str.split(",");
	if (GeoHelper._shouldLngLatBeParsedAsDMS(parts[0].trim(), parts[1].trim())) {
		const lngPieces = parts[0].trim().split(" ");
		const latPieces = parts[1].trim().split(" ");
		console.log("lngLatPieces", parts, lngPieces, latPieces);
		if (lngPieces.length === 4 && latPieces.length === 4) {
			return true;
		}
		return false;
	}
	return parts.length === 2 && !Number.isNaN(parseFloat(parts[0])) && !Number.isNaN(parseFloat(parts[1]));
};
GeoHelper.lngLatCoordinatesToString = (lngLat, lngLatFormat = LngLatFormat.DECIMAL, roundFloatTo = -1) => {
	if (lngLatFormat === LngLatFormat.DMS) {
		return StringHelper.formatDecimalToDMS(lngLat[0], true) + ", " + StringHelper.formatDecimalToDMS(lngLat[1], false);
	}
	if (roundFloatTo > 0) {
		return roundFloat(lngLat[0], roundFloatTo) + ", " + roundFloat(lngLat[1], roundFloatTo);
	}
	return lngLat[0] + ", " + lngLat[1];
};
GeoHelper.parseStringLngLat = (lngLat) => {
	if (lngLat.indexOf(",") > 0) {
		const parts = lngLat.split(",");
		let lng = parts[0].trim();
		let lat = parts[1].trim();
		if (GeoHelper._shouldLngLatBeParsedAsDMS(lng, lat)) {
			const lngPieces = lng.split(" ");
			const latPieces = lat.split(" ");
			const lngDigit = lngPieces[0].substr(0, lngPieces[0].length - 1);
			const latDigit = latPieces[0].substr(0, latPieces[0].length - 1);
			const lngSecond = lngPieces[1].substr(0, lngPieces[1].length - 1);
			const latSecond = latPieces[1].substr(0, latPieces[1].length - 1);
			const lngThird = lngPieces[2].substr(0, lngPieces[2].length - 1);
			const latThird = latPieces[2].substr(0, latPieces[2].length - 1);
			const lngMultiplier = (lngPieces[3] === "W") ? -1 : 1;
			const latMultiplier = (latPieces[3] === "S") ? -1 : 1;
			lng = (parseFloat(lngDigit) + (parseFloat(lngSecond) / 60) + (parseFloat(lngThird) / 3600)) * lngMultiplier;
			lat = (parseFloat(latDigit) + (parseFloat(latSecond) / 60) + (parseFloat(latThird) / 3600)) * latMultiplier;
			return [lng, lat];
		}
		return [parseFloat(lng), parseFloat(lat)];
	}
	return [0, 0];
};
GeoHelper._shouldStrBeParsedAsDMS = (strLngLat) => {
	if (strLngLat.indexOf(",") > 0) {
		const parts = strLngLat.split(",");
		const lng = parts[0].trim();
		const lat = parts[1].trim();
		return GeoHelper._shouldLngLatBeParsedAsDMS(lng, lat);
	}
	return false;
};
GeoHelper._shouldLngLatBeParsedAsDMS = (lng, lat) => {
	lng = "" + lng;
	lat = "" + lat;
	return ((lng.indexOf("°") >= 0 || lng.indexOf("'") >= 0 || lng.indexOf("E") >= 0 || lng.indexOf("W") >= 0) ||
			(lat.indexOf("°") >= 0 || lat.indexOf("'") >= 0 || lat.indexOf("N") >= 0 || lat.indexOf("S") >= 0));
};
GeoHelper.isFeatureCollection = (obj) => {
	return (obj && obj.type && obj.type === "FeatureCollection");
};
GeoHelper.emptyGeoJson = (features = []) => {
	return {
		type: "FeatureCollection",
		features: features
	};
};
GeoHelper.featureAt = (lng = 0, lat = 0, props = {}) => {
	return {
		type: "Feature",
		properties: props,
		geometry: {
			type: "Point",
			coordinates: [lng, lat]
		}
	};
};
GeoHelper.lngLatPointsToArray = (lngLatPoints = []) => {
	const arrayPoints = lngLatPoints.map((lngLat) => {
		return [lngLat.lng, lngLat.lat];
	});
	return arrayPoints;
};
GeoHelper.isNonZeroQuad = (quad) => {
	if (quad[0][0] === 0 &&
		quad[0][1] === 0 &&
		quad[1][0] === 0 &&
		quad[1][1] === 0 &&
		quad[2][0] === 0 &&
		quad[2][1] === 0 &&
		quad[3][0] === 0 &&
		quad[3][1] === 0) {
		return false;
	}
	return true;
};
GeoHelper.isNonZeroExtent = (extent) => {
	if (extent[0] === 0 &&
		extent[1] === 0 &&
		extent[2] === 0 &&
		extent[3] === 0) {
		return false;
	}
	return true;
};
GeoHelper.calcQuadFromExtent = (extent) => {
	// extent[0]; // min lng
	// extent[1]; // max lng
	// extent[2]; // min lat
	// extent[3]; // max lat

	const q = [
		[0, 0], // bottom left
		[0, 0], // bottom right
		[0, 0], // top right
		[0, 0] // top left
	];
	q[0][0] = extent[0];
	q[0][1] = extent[2];

	q[1][0] = extent[1];
	q[1][1] = extent[2];

	q[2][0] = extent[1];
	q[2][1] = extent[3];

	q[3][0] = extent[0];
	q[3][1] = extent[3];

	return q;
};

/**
 * @param quadGeometry [[0,0],[0,0],[0,0],[0,0]]
 * @return [minx, maxx, miny, maxy]
 */
GeoHelper.calcExtentFromQuad = (quadGeometry) => {
	let minx = 999;
	let miny = 999;
	let maxx = -999;
	let maxy = -999;
	for (let i = 0; i < quadGeometry.length; i++) {
		const point = quadGeometry[i];
		if (point[0] < minx) {
			minx = point[0];
		}
		if (point[0] > maxx) {
			maxx = point[0];
		}
		if (point[1] < miny) {
			miny = point[1];
		}
		if (point[1] > maxy) {
			maxy = point[1];
		}
	}
	return [minx, maxx, miny, maxy];
};

// @return [x,y]
GeoHelper.calcCenter = (feature) => {
	const bounds = bbox(feature);
	// console.log("feature", feature, "bounds", bounds);
	return [
		(bounds[0] + bounds[2]) * 0.5,
		(bounds[1] + bounds[3]) * 0.5
	];
};

// @return [x,y]
GeoHelper.calcTopLeft = (feature) => {
	const coordsTL = [999999, -99999];
	for (let j = 0; j < feature.geometry.coordinates[0].length; j++) {
		const point = feature.geometry.coordinates[0][j];
		if (point[0] < coordsTL[0]) {
			coordsTL[0] = point[0];
		}
		if (point[1] > coordsTL[1]) {
			coordsTL[1] = point[1];
		}
	}
	return coordsTL;
};
// @return [x,y]
GeoHelper.calcTopRight = (feature) => {
	const coordsTR = [-999999, -99999];
	for (let j = 0; j < feature.geometry.coordinates[0].length; j++) {
		const point = feature.geometry.coordinates[0][j];
		if (point[0] > coordsTR[0]) {
			coordsTR[0] = point[0];
		}
		if (point[1] > coordsTR[1]) {
			coordsTR[1] = point[1];
		}
	}
	return coordsTR;
};

// @return [x,y]
GeoHelper.calcTopCenter = (feature) => {
	const coordsTL = GeoHelper.calcTopLeft(feature);
	const coordsTR = GeoHelper.calcTopRight(feature);
	const coordX = coordsTL[0] + ((coordsTR[0] - coordsTL[0]) * 0.5);
	const coordY = coordsTL[1];
	const coords = [coordX, coordY];
	return GeoHelper.clampLngLat(coords);
};
// @return [x,y]
GeoHelper.calcBottomRight = (feature) => {
	const coordsBR = [-999999, -99999];
	for (let j = 0; j < feature.geometry.coordinates[0].length; j++) {
		const point = feature.geometry.coordinates[0][j];
		if (point[0] > coordsBR[0]) {
			coordsBR[0] = point[0];
		}
		if (point[1] < coordsBR[1]) {
			coordsBR[1] = point[1];
		}
	}
	return coordsBR;
};
// @return [x,y]
GeoHelper.calcBottomLeft = (feature) => {
	const coordsBR = [-999999, -99999];
	for (let j = 0; j < feature.geometry.coordinates[0].length; j++) {
		const point = feature.geometry.coordinates[0][j];
		if (point[0] < coordsBR[0]) {
			coordsBR[0] = point[0];
		}
		if (point[1] < coordsBR[1]) {
			coordsBR[1] = point[1];
		}
	}
	return coordsBR;
};

GeoHelper.findClosestPointByLngLat = (array, lng, lat) => {
	let closestPointIndex = null;
	let closestPointDistanceSq = 999999999;
	for (let i = 0; i < array.length; i++) {
		const distSq = DistanceUtil.distanceSquared(lng, lat, array[i].lng, array[i].lat);
		if (distSq < closestPointDistanceSq) {
			closestPointDistanceSq = distSq;
			closestPointIndex = i;
		}
	}
	return closestPointIndex;
};

GeoHelper.featureCollectionPoints = (coordinatesArray) => {
	const points = [];
	for (let i = 0; i < coordinatesArray.length; i++) {
		points.push(GeoHelper.featurePoint(coordinatesArray[i]));
	}
	return {
		type: "FeatureCollection",
		features: points
	};
};
GeoHelper.featureCollectionLineString = (coordinatesArray) => {
	return {
		type: "FeatureCollection",
		features: [
			GeoHelper.featureLineString(coordinatesArray)
		]
	};
};
GeoHelper.featurePoint = (coordinates) => {
	return {
		type: "Feature",
		properties: {},
		geometry: {
			type: "Point",
			coordinates: coordinates
		}
	};
};

GeoHelper.featureCollectionPolygon = (coordinatesArray) => {
	return {
		type: "FeatureCollection",
		features: [
			{
				type: "Feature",
				properties: {},
				geometry: {
					type: "Polygon",
					coordinates: [
						coordinatesArray
					]
				}
			}
		]
	};
};

// To make this a rect, do: BL, BR, TR, TL, BL
GeoHelper.featureLineString = (coordinatesArray, properties = {}) => {
	return {
		type: "Feature",
		properties: properties,
		geometry: {
			type: "LineString",
			coordinates: coordinatesArray
		}
	};
};
GeoHelper.imageRect = (url, coordinatesArrayBounds) => {
	return {
		type: "image",
		url: url,
		coordinates: coordinatesArrayBounds
	};
};

// Force the shortest line if it crosses the antimeridian -180/+180
GeoHelper.fixLineWrapAround = (lineStringFeature) => {
	let prevLng = 0;
	for (let i = 0; i < lineStringFeature.geometry.coordinates.length; i++) {
		let lng = lineStringFeature.geometry.coordinates[i][0];
		lng += lng - prevLng > 180
			? -360
			: prevLng - lng > 180
				? 360
				: 0;
		prevLng = lng;
		lineStringFeature.geometry.coordinates[i][0] = lng;
	}
	return lineStringFeature;
};

// downsampleRate is default is one day
// todo: pass a filtering function?
GeoHelper.downsample = (dataset, downsampleRate = 86400000) => {
	// let lastTimeStamp = Date.parse(new Date(0));
	let lastItem = dataset[0];
	for (let i = 0; i < dataset.length - 1; i++) {
		let thisItem = dataset[i];
		const nextItem = dataset[i + 1];

		if (thisItem === null) {
			thisItem = lastItem;
		}
		else {
			lastItem = thisItem;
		}

		const thisTimestamp = Date.parse(thisItem.properties.timestamp);
		const nextTimestamp = Date.parse(nextItem.properties.timestamp);
		const timeBetweenEntries = (nextTimestamp - thisTimestamp);
		if (timeBetweenEntries < downsampleRate) {
			dataset[i + 1] = null;
			// console.log('removing', i, timeBetweenEntries);
		}
	}
	return dataset.filter((d) => {
		return d != null;
	});
};

// gapLength is default is one day
// dataset must be feature/points
GeoHelper.generateTimeGapLines = (dataset, gapLength = 86400000) => {
	const gapsLines = [];
	for (let i = 0; i < dataset.length - 1; i++) {
		const thisItem = dataset[i];
		const nextItem = dataset[i + 1];
		// TODO: consider use of VesselProperty.IMO.
		if (thisItem.properties.imo === nextItem.properties.imo) {
			const thisItemTime = Date.parse(thisItem.properties.timestamp);
			const nextItemTime = Date.parse(nextItem.properties.timestamp);
			const timeBetweenEntries = (nextItemTime - thisItemTime);
			if (timeBetweenEntries > gapLength) {
				gapsLines.push({
					type: "Feature",
					properties: {
						imo: thisItem.properties.imo,
						fromSpeed: thisItem.properties.speed,
						toSpeed: nextItem.properties.speed,
						fromTimestamp: thisItemTime,
						toTimestamp: nextItemTime,
						duration: timeBetweenEntries
					},
					geometry: {
						type: "LineString",
						coordinates: [thisItem.geometry.coordinates, nextItem.geometry.coordinates]
					}
				});
			}
		}
	}
	return gapsLines;
};

// returns Hours
GeoHelper.calculateTime = (lngLatFrom, lngLatTo, speed, speedUnits) => {
	speed = parseFloat(speed);
	if (!ValidationHelper.isValidNonZeroNumber(speed, "Speed")) {
		return 0;
	}
	const distanceMiles = GeoHelper.calculateDistanceMiles(lngLatFrom, lngLatTo);
	const distanceNauticalMiles = DistanceUtil.convert(distanceMiles, DistanceUnit.MILES, DistanceUnit.NAUTICAL_MILES);
	if (speedUnits === DistanceUnit.NAUTICAL_MILES) {
		const hours = distanceNauticalMiles / speed;
		return hours;
	}
	// TODO: other units
	return "";
};
GeoHelper.calculateSpeed = (lngLatFrom, lngLatTo, timeInMinutes) => {
	timeInMinutes = parseFloat(timeInMinutes);
	if (!ValidationHelper.isValidNonZeroNumber(timeInMinutes, "Time")) {
		return 0;
	}

	const distanceMiles = GeoHelper.calculateDistanceMiles(lngLatFrom, lngLatTo);
	const result = (distanceMiles / (timeInMinutes / 60));

	if (Number.isNaN(result)) {
		throw new Error("Result is NaN");
	}
	else if (!Number.isFinite(result)) {
		throw new Error("Result is Infinity");
	}
	return roundFloat(result, 2);
};
GeoHelper.calculateDistanceMiles = (lngLatFrom, lngLatTo) => {
	const line = lineString([[lngLatFrom.lng, lngLatFrom.lat], [lngLatTo.lng, lngLatTo.lat]]);
	return length(line, { units: DistanceUnit.MILES });
};

export default GeoHelper;
